import { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";
import { PricingProvider } from "@/lib/PricingContext";

import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ActivityStrip from "@/components/ActivityStrip";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import Industries from "@/components/Industries";
import Process from "@/components/Process";
import VerfahrenFinder from "@/components/VerfahrenFinder";
import VerfahrenCompare from "@/components/VerfahrenCompare";
import PreisShow from "@/components/PreisShow";
import KiZeichnungsAnalyse from "@/components/KiZeichnungsAnalyse";
import VoiceAnfrage from "@/components/VoiceAnfrage";
import LiveWerkstatt from "@/components/LiveWerkstatt";
import WerkstourScroll from "@/components/WerkstourScroll";
import FabrikKarte from "@/components/FabrikKarte";
import Routen from "@/components/Routen";
import Jobs from "@/components/Jobs";
import BeforeAfter from "@/components/BeforeAfter";
import CO2Dashboard from "@/components/CO2Dashboard";
import Heritage from "@/components/Heritage";
import LogoWall from "@/components/LogoWall";
import Team from "@/components/Team";
import Certificates from "@/components/Certificates";
import Glossar from "@/components/Glossar";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Assistant from "@/components/Assistant";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieBanner from "@/components/CookieBanner";
import LoadingSplash from "@/components/LoadingSplash";
import LanguageSuggestion from "@/components/LanguageSuggestion";
import LanguageDetectedToast from "@/components/LanguageDetectedToast";
import Admin from "@/pages/Admin";
import AdminPricing from "@/pages/AdminPricing";
import AGB from "@/pages/AGB";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import NotFound from "@/pages/NotFound";
import useReveal from "@/hooks/useReveal";

const Landing = () => {
  const rootRef = useRef(null);
  useReveal(rootRef);

  return (
    <div ref={rootRef} className="App relative">
      <Navigation />
      <main>
        <Hero />
        <Marquee />
        <ActivityStrip />
        <About />
        <WerkstourScroll />
        <Services />
        <BeforeAfter />
        <VerfahrenFinder />
        <VerfahrenCompare />
        <PreisShow />
        <KiZeichnungsAnalyse />
        <LiveWerkstatt />
        <FabrikKarte />
        <Routen />
        <WhyChooseUs />
        <Industries />
        <Process />
        <Heritage />
        <CO2Dashboard />
        <LogoWall />
        <Team />
        <Jobs />
        <Certificates />
        <Glossar />
        <VoiceAnfrage />
        <Contact />
      </main>
      <Footer />
      <Assistant />
      <WhatsAppButton />
      <CookieBanner />
      <LanguageSuggestion />
      <LanguageDetectedToast />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#141416",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: 0,
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <I18nProvider>
      <PricingProvider>
        <BrowserRouter>
          <LoadingSplash />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/preise" element={<AdminPricing />} />
            <Route path="/preise" element={<AdminPricing />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </PricingProvider>
    </I18nProvider>
  );
}

export default App;
